
import * as defaultImport from "numbro";
export * from "numbro";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
